import { ComponentType, type IConfig } from '../../types';
import { ComponentConfigType } from '../../utils/data-parser';
import { BASIC_JSON_LOGIC_TOOLTIP, BASIC_VALUE_TOOLTIP } from '../../utils';

export const config: IConfig = {
  component: ComponentType.ListPage,
  configGroups: [
    {
      title: 'Component Settings',
      items: [
        {
          name: 'modelIds',
          label: 'Model IDs',
          valueComponent: {
            type: 'ModelFilters',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
        {
          name: 'dataFilters',
          label: 'Filters',
          valueComponent: {
            type: 'DataFilters',
          },
          configTypes: [
            ComponentConfigType.Value,
            ComponentConfigType.JsonLogic,
          ],
          tooltips: [
            { key: ComponentConfigType.Value, value: BASIC_VALUE_TOOLTIP },
            {
              key: ComponentConfigType.JsonLogic,
              value: BASIC_JSON_LOGIC_TOOLTIP,
            },
          ],
        },
      ],
    },
    {
      title: 'Component Styles',
      component: 'CssSettings',
    },
  ],
};
